import React from 'react';
import PropTypes from 'prop-types';

const Taxes = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 114 114"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".2"
      d="M57 114c31.48 0 57-25.52 57-57S88.48 0 57 0 0 25.52 0 57s25.52 57 57 57z"
      fill="#B1E0E2"
    />
    <path
      d="M85.82 94.545l-57.32.463M82.685 57.857A26.79 26.79 0 0056.358 32.92 26.754 26.754 0 0030.46 58.107l52.226-.25z"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.23 65.27h4.453a1.959 1.959 0 001.924-1.96v-3.562a1.924 1.924 0 00-1.924-1.924l-53.865.428a1.924 1.924 0 00-1.888 1.923v3.563a1.924 1.924 0 001.923 1.924l43.178-.357M55.434 19.416l.107 13.395M55.575 19.201c3.342.942 6.89.867 10.189-.214 0 0 0 0 0 0v5.95a11.614 11.614 0 01-10.403.25v-5.915l.214-.07zM46.348 66.296l.213 28.215M34.45 66.407l.213 28.215M79.23 65.266l.25 28.998M67.367 66.156l.214 28.18"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Taxes.defaultProps = {
  className: '',
};

Taxes.propTypes = {
  className: PropTypes.string,
};

export default Taxes;
